import { render, staticRenderFns } from "./ColumnEditModal.vue?vue&type=template&id=dd32c122&scoped=true&"
import script from "./ColumnEditModal.vue?vue&type=script&lang=js&"
export * from "./ColumnEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ColumnEditModal.vue?vue&type=style&index=0&id=dd32c122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd32c122",
  null
  
)

export default component.exports